import LoadingPage from '../../components/Loading/LoadingPage'
export default function Tester() {
  return (
    <>
      <LoadingPage loadingMessage={true} />
    </>
  )
}
